/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ClassroomdisciplineClassModulesIdQueryResponse,
  GetApiV1ClassroomdisciplineClassModulesIdPathParams,
  GetApiV1ClassroomdisciplineClassModulesId401,
  GetApiV1ClassroomdisciplineClassModulesId404,
  GetApiV1ClassroomdisciplineClassModulesId500,
} from "../../types/classPlanningClassModuleController/GetApiV1ClassroomdisciplineClassModulesId.ts";

function getGetApiV1ClassroomdisciplineClassModulesIdUrl(
  id: GetApiV1ClassroomdisciplineClassModulesIdPathParams["id"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/classroomdiscipline/class-modules/${id}` as const,
  };
  return res;
}

/**
 * @description Retorna o detalhe do Módulo (turmas, disciplinas, recorrências e aulas) para a tela de edição. **(Requer Authorization para autenticação)**
 * @summary Obter Módulo por ID (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/class-modules/:id}
 */
export async function getApiV1ClassroomdisciplineClassModulesId(
  id: GetApiV1ClassroomdisciplineClassModulesIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ClassroomdisciplineClassModulesIdQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ClassroomdisciplineClassModulesId401
      | GetApiV1ClassroomdisciplineClassModulesId404
      | GetApiV1ClassroomdisciplineClassModulesId500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ClassroomdisciplineClassModulesIdUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
